import { environment } from '$env/environment';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const ignoredPaths = ['/assets'];

/**
 * Prefixes all requests with `environment.serverUrl`.
 */
@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (ignoredPaths.some((path) => request.url.startsWith(path))) {
      return next.handle(request);
    }

    if (
      request.url.startsWith('http://') ||
      request.url.startsWith('https://')
    ) {
      // Ignore absolute URL
      return next.handle(request);
    }

    request = request.clone({ url: environment.serverUrl + request.url });
    return next.handle(request);
  }
}
